import ApiEndpoints from 'api/endpoints'
import { useRequest } from 'hooks'
import { CustomerMaskedDataRes } from 'models'

export const useGetCustomerMaskedData = (nip: string, token: string, enabled: boolean) => {
  return useRequest<CustomerMaskedDataRes>(ApiEndpoints.getCustomerMaskedData(nip, token), { enabled, retry: 1 })
}
